/*
 * Entry point of the application.
 * Only platform bootstrapping code should be here.
 * For app-specific initialization, use `app/app.component.ts`.
 */

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from '@bo-env/environment';

if (environment.production) {
  enableProdMode();
}

/**
 * This is a workaround to save the state parameter from the IDP login page.
 * The state parameter is not available in the URL after the redirect from the IDP login page.
 * The state parameter is needed to exchange the IDP token for a local token.
 *
 * The state parameter is saved in the sessionStorage.
 *
 * The state parameter is removed from the URL.
 *
 *
 */
const urlParams = new URLSearchParams(window.location.search);
const stateParam = urlParams.get('state');

if (stateParam) {
  // In sessionStorage oder localStorage ablegen
  // wenn der state param vorhanden ist, legen wir die ganze url in sessionStorage ab
  sessionStorage.setItem('authState', window.location.href);
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));
